// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/styles/" + chunkId + "." + "795d5a1da3093fe2" + ".css"
}